import {Locale} from './locale';


export interface CommentObject {
  comment?: string;
  created_at: Date;
  deleted: boolean;
  id: number;
  locale: Locale;
  mugshot: MugshotObject | string;
  screen_name: string;
  updated: boolean;
  updated_at: Date;
  user_id?: number;
  children?: CommentObject[];
  parent_id?: number;
  link?: {type: string; url: string};
}

export interface MugshotObject {
  id: number;
  filename: string;
}

export function mugshotExists(input: MugshotObject | string): input is MugshotObject {
  return (input as MugshotObject).id !== undefined;
}
